import React from "react";
import {Button, Container, Dimmer, Dropdown, Grid, Icon, Loader} from "semantic-ui-react";
import {getApiCountries, getUserLocation} from "../../../Api/Api";
import Logo from "../../../images/intersog_logo_white.svg";
import ProgressContainer from "../../Progress/ProgressContainer";

class Location extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.userData.location.length === 0){
            getUserLocation().then(data => {
                if(data.status == 'success'){
                    this.props.setUserData(data);
                }
            });
        }

        if (this.props.userData.countries.length === 0){
            this.props.isLoading(true);
            getApiCountries().then(data => {
                if(data.countries.length > 0){
                    this.props.getCountries(data.countries);
                    this.props.isLoading(false);
                }
            });
        }
    }

    render() {

        let bntText = "Start";

        if(this.props.flow.history[this.props.flow.history.length-1] > 1) {
            bntText = "Update";
        }

        return (
            <div>
            <div id={'location'} className={'step-section'}>
                <Grid>
                    <Grid.Column padded={'horizontally'}>
                        <Container className={"pre-header"}>
                            <h2>IT Team Cost Calculator</h2>
                            <h4>With Intersog, you get access to <strong>250+</strong> top software developers ready to commit from day one.</h4>
                        </Container>
                        <ProgressContainer/>
                        <Container className={"location"}>
                            <h3>Please choose your country below if it is different from the one automatically determined by our system.</h3>
                            <Dimmer active={this.props.userData.isLoading} inverted>
                                <Loader size='small'></Loader>
                            </Dimmer>
                            <Dropdown
                                width={4}
                                minCharacters={2}
                                onChange={this.props.setCustomCountryCode}
                                onSearchChange={''}
                                name={"country"}
                                skey={"country"}
                                placeholder='Country'
                                noResultsMessage={"Country not found"}
                                search fluid selection
                                options={this.props.userData.countries}
                                value={this.props.userData.location.countryCode}
                                text={''}
                            />
                        </Container>
                        <Container className={"navigation"}>
                            <Button className={`intersog-btn`} onClick={() =>{this.props.setNextStep(2);this.props.changeStep();this.props.scrollToStep(2);}}>
                                {bntText}
                            </Button>
                        </Container>
                    </Grid.Column>
                </Grid>
            </div>
            </div>
        )

    }

}

export default Location;